import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import TextField from '@mui/material/TextField';
import MetaData from '../Layouts/MetaData';

const VendorLogin = () => {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submitHandler = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await axios.post('/api/v1/vendor/login', { email, password });
            navigate('/vendor/dashboard');
        } catch (error) {
            enqueueSnackbar(error?.response?.data?.message || "Login failed", { variant: "error" });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
            <MetaData title="Vendor Login | 1313 Mart" />

            <form onSubmit={submitHandler} className="bg-white shadow-lg rounded-lg p-8 flex flex-col gap-4 w-full max-w-sm">
                <div className="text-center mb-2">
                    <h1 className="text-xl font-bold text-primary-orange">1313 Mart</h1>
                    <p className="text-sm text-gray-500">Vendor Portal</p>
                </div>

                <TextField label="Email" type="email" size="small" required value={email} onChange={(e) => setEmail(e.target.value)} />
                <TextField label="Password" type="password" size="small" required value={password} onChange={(e) => setPassword(e.target.value)} />

                <button type="submit" disabled={loading} className="bg-primary-orange py-2.5 text-white font-medium rounded shadow hover:shadow-lg disabled:opacity-60">
                    {loading ? "Logging in..." : "Log In"}
                </button>
            </form>
        </div>
    );
};

export default VendorLogin;